import {Pipe, PipeTransform} from '@angular/core';
import {SortDescriptor}      from '@progress/kendo-data-query';

/**
 * find a SortDescriptor by FieldId
 */
@Pipe({
  name: 'findSort'
})
export class FindSortPipe implements PipeTransform {

  transform(value: SortDescriptor[], args?: string): SortDescriptor {
    return value.Find(i => i.field === args);
  }

}
